import styles from "./AiInsights.module.css";
import courseImg from "../../../../assets/images/TalentDashboard/courdethumb.png";

export default function CourseThumb() {
  return (
    <div className={styles.courseThumb}>
      <img className={styles.courseThumbImg} src={courseImg} alt="" />
    </div>
  );
}
